import React, { useState } from 'react';
import { Dialog } from '@cw-ui/feedback-components';
import { Button } from '@cw-ui/form-components';
import { IconButton, ThemeProvider, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { injectIntl } from 'react-intl';
import { formatMessage } from 'cw-ui-core';
import { getTheme } from '@cw-ui/asio-neon-themes';
import Locale from 'src/Locale';
import Loader from 'src/LoaderCustom';
import PropTypes from 'prop-types';
import UserAgreementCard from '../UserAgreementCard';

const AsioUpgradeDialog = ({ onCloseIconClick, onNeedHelpClick, isFullAccountUpgrade, onFullAccountUpgradeClick, isAutomateInAsioUpgrade,onAutomateInAsioUpgradeClick }) => {
  const theme = getTheme('light');
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const handleConfirmClick = async () => {
    setLoading(true);
    if (isFullAccountUpgrade) {
      await onFullAccountUpgradeClick();
    } else if (isAutomateInAsioUpgrade) {
      await onAutomateInAsioUpgradeClick();
    }

    setLoading(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        open
        aria-labelledby="asio-upgrade-dialog"
        aria-describedby="asio-upgrade-dialog-description"
      >
        <Dialog.Title id="asio-upgrade-dialog">
         {isAutomateInAsioUpgrade ? formatMessage(Locale.asio_upgrade_dialog_automate_title) : formatMessage(Locale.asio_upgrade_dialog_title)}
        </Dialog.Title>
        <IconButton
          aria-label="close"
          onClick={onCloseIconClick}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.icon.iconPrimary
          }}
        >
          <CloseIcon />
        </IconButton>
        <Dialog.DialogContent>
          <Typography fontSize={14} fontWeight={400} sx={{ whiteSpace: 'pre-line' }}>
            {isAutomateInAsioUpgrade ? formatMessage(Locale.asio_upgrade_dialog_automate_upgrade_text) : isFullAccountUpgrade ? formatMessage(Locale.asio_upgrade_dialog_full_upgrade_text) : formatMessage(Locale.asio_upgrade_dialog_standard_upgrade_text)}

          </Typography>
          <UserAgreementCard onAgreementChange={setIsChecked} isChecked={isChecked}/>
        </Dialog.DialogContent>
        <Dialog.DialogActions>
          <Button
            size="medium"
            variant="outlined"
            color="ghost"
            onClick={onCloseIconClick}
          >
            {formatMessage(Locale.back)}
          </Button>
          <div style={{ flex: '1 0 0' }} />
          <Button
            size="medium"
            variant="outlined"
            color="secondary"
            onClick={onNeedHelpClick}
          >
            {formatMessage(Locale.need_Help)}
          </Button>
          <Button
            size="medium"
            variant="contained"
            color="primary"
            disabled={!isChecked }
            onClick={()=> handleConfirmClick()}
            sx={{backgroundColor: loading ? 'white' : ''}}
          >
           {loading ? <Loader/> : formatMessage(Locale.confirm)}
          </Button>
        </Dialog.DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

AsioUpgradeDialog.propTypes = {
  onCloseIconClick: PropTypes.func, 
  onNeedHelpClick: PropTypes.func, 
  onAgreementChange: PropTypes.func,
  isFullAccountUpgrade: PropTypes.bool,
  isAutomateInAsioUpgrade: PropTypes.bool
};

export default injectIntl(AsioUpgradeDialog);
